import {linkToRef} from "../routing/places";
import {ReferenceWidget} from "../widgets/ReferenceWidget";
import {fieldValue, getFirstNotEmptyObj, getFirstNotNullObj, nextId} from "../common/NamaCommon";
import {translateRef} from "../common/Translator";
import * as FieldType from "../constants/FieldType";
import {calcByLanguage} from "../views/treeView/TreeModelProvider";
import {addImgPartToName, mainFileImgTag} from "../common/AttachmentLinkUtil";
import * as ShowImageIn from "../constants/ShowImageIn";


export function referenceColumnEditor(fieldMetadata, trimmedFieldId, grid) {
    return (container, options) => {
        let widget = new ReferenceWidget({owner: grid, fieldMetadata, cellOptions: options});
        widget.inputName = options.field;
        grid.afterAddingToGridAction(widget, options, trimmedFieldId, container);
    }
}

export function refCodeOrNameEditor(trimmedFieldId) {
    return (container, options) => {
        let reference = options.model[trimmedFieldId];
        if (reference)
            container.text(options.field.endsWith("code") ? reference.code : calcByLanguage(reference.name1, reference.name2));
        else
            container.text("");
        container.removeClass("k-edit-cell");
    }
}

export function imgColumnTemplate(trimmedFieldId) {
    return (dataItem) => {
        let ref = fieldValue(dataItem, trimmedFieldId);
        if (!ref)
            return "";
        let container = $(`<div></div>`);
        container.append(mainFileImgTag(ref.entityType, null, ShowImageIn.GridSeparateColumn, ref.id, true, undefined, undefined, ref));
        return container.html();
    }
}

export function constructRefTemplate(ref, fieldMetadata, trimmedFieldId) {
    let id = nextId();
    let href = ref && ref.id ? linkToRef(ref) : "";
    let s = `<div class="grid-ref-row row align-items-center w-100"><span class="col-lg-10 d-flex " title='${translateRef(ref)}'>${translateRef(ref)}</span>`;
    if (ref && fieldMetadata.fieldId === "lines.account" && (fieldMetadata.fieldType === FieldType.Reference || fieldMetadata.fieldType === FieldType.Genericreference))
        s = `<div class="grid-ref-row row align-items-center w-100"><span  class="col-lg-10 d-flex" title='${ref.code}'>${ref.code}</span>`;
    let entityType = ref ? getFirstNotEmptyObj(ref.entityType, fieldMetadata.referencedEntityType) : fieldMetadata.referencedEntityType;
    let refId = ref && ref.id ? ref.id : "";
    s += `<div class ="gridBtnsContainer col-lg-2 px-1 d-flex align-items-center">`;
    s += `<a role="button" fieldId="${trimmedFieldId}" fieldEntityType ="${entityType}" columnId = "${fieldMetadata.fieldId}" id="${id}search" class="column-search-btn gridButton"><i class="fa-solid fa-search text-secondary px-1"></i></a>`;
    s += `<a role="button" href="${href}" fieldId="${trimmedFieldId}" fieldEntityType ="${entityType}" columnId = "${fieldMetadata.fieldId}" id="${id}goto" class="column-go-to-button gridButton gridRefToGo" refid="${refId}"><i class="fa-solid fa-arrow-right text-secondary px-1"></i></a>`;
    s += `</div>`;
    s += `</div>`;
    return ref ? addImgPartToName(entityType, ref.id, s, ShowImageIn.GridColumns, ref) : s;
}

export function referenceTemplate(trimmedFieldId, fieldMetadata) {

    return (dataItem) => {
        let ref = fieldValue(dataItem, trimmedFieldId);
        return constructRefTemplate(ref, fieldMetadata, trimmedFieldId);
    }
}

export function referenceCodeTemplate(trimmedFieldId) {

    return (dataItem) => {
        let ref = fieldValue(dataItem, trimmedFieldId);
        return ref ? `<span title='${ref.code}'>${ref.code}</span>` : "";
    }
}

export function referenceNameTemplate(trimmedFieldId) {

    return (dataItem) => {
        let ref = fieldValue(dataItem, trimmedFieldId);
        if (!ref)
            return "";
        let val = calcByLanguage(getFirstNotNullObj(ref.descriptor1, ref.name1), getFirstNotNullObj(ref.descriptor2, ref.name2));
        return ref ? `<span title='${val}'>${val}</span>` : "";
    }
}